'use client';

import { Children } from 'react';
import { useBreakpoints } from '../../../lib/hooks/useBreakpoints';
import { c } from '../../../utils/tailwind-merge';
import {
  ProductListHeader,
  ProductListSeeMoreLink,
} from '../ProductListHeader';
import { ProductListInfo } from '../ProductListInfo';
import type { ProductListingProps } from './ProductListing.types';

const MAX_CARDS_MOBILE_TABLET = 4;

export const ProductListing = ({
  className = '',
  name,
  href,
  info,
  isEmpty,
  children,
  hideUserAvatar,
  microcopy,
}: ProductListingProps) => {
  const breakpoints = useBreakpoints();

  const displayedChildren =
    breakpoints === null || breakpoints.isDesktop
      ? children
      : Children.toArray(children).slice(0, MAX_CARDS_MOBILE_TABLET);

  return (
    <section
      className={c('flex flex-col gap-4 lg:gap-5', className)}
      data-test="product-listing"
    >
      <div>
        <ProductListHeader
          type="seeMore"
          size="lg"
          name={name}
          href={href}
          microcopy={{
            seeMore: microcopy.seeMore,
            seeMoreAria: microcopy.seeMoreAria,
          }}
        />
        <ProductListInfo
          {...info}
          hideUserAvatar={hideUserAvatar}
          microcopy={microcopy.info}
        />
      </div>
      {isEmpty ? null : (
        <>
          <div
            className="grid grid-cols-2 gap-4 md:grid-cols-4 lg:grid-cols-5 lg:gap-5"
            data-test="product-listing-grid"
          >
            {displayedChildren}
          </div>
          <ProductListSeeMoreLink
            href={href}
            name={name}
            microcopy={{
              seeMore: microcopy.seeMore,
              seeMoreAria: microcopy.seeMoreAria,
            }}
            className="ml-1.5 md:hidden"
          />
        </>
      )}
    </section>
  );
};

ProductListing.displayName = 'ProductListing';
